import rConf from "./rConf"

const routes =[
    {path:"/", component: rConf.LoginForm},
    {path:"/home", component: rConf.Home},
    {path:"/about", component: rConf.About},
    {path:"/contact", component: rConf.Contact},
    {path:"/service", component: rConf.ServiceChecklist},
    {path:"/gunQuotation", component: rConf.GunQuotation},
    {path:"/reportings", component: rConf.ReportingSheets},
    {path:"/credentials", component: rConf.Credentials},
    {path:"/lead-to-sheet", component: rConf.LeadToSheet},
    {path:"/components-issue", component: rConf.ComponentsIssues},
    {path:"/quotations", component: rConf.QuotationList},
    {path:"/client_list", component: rConf.ClientList},
    {path:"/service_report_list", component: rConf.ServiceReportsList},
    {path:"/indiamart", component: rConf.AdditionalServices},
    {path:"/imleads", component: rConf.IMLeads},
    {path:"/downloads", component: rConf.Downloads},
    {path:"/testing", component: rConf.Testing},
    {path:"/dashboard", component: rConf.Dashboard},
    {path:"/sparesold", component: rConf.ClientSellingRecord},
    {path:"/emails", component: rConf.EmailsToClipBoardForm},
    {path:"/installationemails", component: rConf.EmailsInstallation},
]

export default routes;